module.exports = __webpack_public_path__ + "img/城市静态交通.ecae55e7.png";